var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.625L13.5 1.625M13.5 1.625H9.5M13.5 1.625L8.16667 6.95833M6.16667 2.95833H4.7C3.5799 2.95833 3.01984 2.95833 2.59202 3.17632C2.21569 3.36807 1.90973 3.67403 1.71799 4.05035C1.5 4.47818 1.5 5.03823 1.5 6.15833V10.425C1.5 11.5451 1.5 12.1052 1.71799 12.533C1.90973 12.9093 2.21569 13.2153 2.59202 13.407C3.01984 13.625 3.5799 13.625 4.7 13.625H8.96667C10.0868 13.625 10.6468 13.625 11.0746 13.407C11.451 13.2153 11.7569 12.9093 11.9487 12.533C12.1667 12.1052 12.1667 11.5451 12.1667 10.425V8.95833",
    stroke: "#10141B",
    strokeWidth: 1.336,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.4904cab6bc8f2e3ca316fd62415148a9.svg";
export { ForwardRef as ReactComponent };